module.exports = __webpack_public_path__ + "static/media/weather-boy.b57ce382.jpg";